import { Box, Grid, styled } from '@grupoboticario/flora-react';

const styles = {
  OrderWrapper: styled('div', {
    marginBottom: '$10',
  }),

  Grid: styled(Grid, {
    gap: '$4',
    padding: '$6 0',

    '@tablet': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  }),

  Wrapper: styled(Box, {
    background: '$backgroundPrimary',
  }),
};

export default styles;
